import { UserRole } from '../../../Model/User';

const texts = {
  internalUsers: 'Internal Users',
  tabLabels: {
    [UserRole.IS]: 'IS Users',
    [UserRole.AC]: 'AC Users',
    [UserRole.CAM]: 'CAM Users',
    [UserRole.CPS]: 'CPS Users',
    [UserRole.SDR]: 'SDR Users',
    [UserRole.SUPPORT]: 'Support Users',
  },
};

export default texts;
